export default __webpack_public_path__ + "static/media/item-6.ed8d4740.jpg";